
export class AverageWeeklyWage {
  id: number;
  aweDate: Date;
  awe: number;
  isDelete: boolean;
};
